import styled from "styled-components";

export const Wrapper = styled.div`
  width: 370px;
  background-color: #ffffff;
  border-left: 1px solid #e0e0e0;
  height: 100%;
  overflow-y: auto;
`;
